// extracted by mini-css-extract-plugin
export var buttonContainer = "_9u-1";
export var fontSizeSelect = "_9u-3";
export var formatSelect = "_9u-2";
export var formats = "_9u-4";
export var hidden = "_9u-5";
export var icon = "_9u-6";
export var select = "_9u-0";